import { X } from "react-feather";
import { Href } from "../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { profileSideBarToggle } from "../../../ReduxToolkit/Reducers/Messenger/Messenger";
import { dynamicImage, Image } from "../../../Utils";
import ContactIcon from "./ContactIcon";
import ContactInformation from "./ContactInformation";
import GroupChat from "./GroupChat";
import Messages from "./Messages";
import SharedMedia from "./SharedMedia";

const ProfileSection = () => {
  const { selectedUser } = useAppSelector((state) => state.chat);
  const dispatch = useAppDispatch();
  return (
    <aside className="chatzy-right-sidebar">
      <div className="custom-scroll right-sidebar">
        <div className="contact-profile-img">
          <div className={`profile ${selectedUser?.onlineStatus}`}>
            {selectedUser?.thumb ? <Image className="bg-img img-fluid" src={dynamicImage(selectedUser.profileImg)} alt="Avatar" /> : <span>{selectedUser?.name.split(" ").map((name) => name[0])}</span>}
            <a className="icon-btn btn-sm close-profile ms-3" href={Href} onClick={() => dispatch(profileSideBarToggle())}>
              <X />
            </a>
            <div className="profile-content">
              <h2 className="text-white">{selectedUser?.name ? selectedUser?.name : "Lea"}</h2>
              <h4 className="text-white">+91 9860000004</h4>
            </div>
          </div>
        </div>
        <ContactIcon />
        <SharedMedia />
        <Messages />
        <GroupChat />
        <ContactInformation />
      </div>
    </aside>
  );
};

export default ProfileSection;
